export enum CrawlingType {
  NotAllowed = 'crawling_not_allowed',
  AllowedWithKamVerification = 'crawling_allowed_with_kam_verification',
  AllowedWithoutKamVerification = 'crawling_allowed_without_kam_verification',
}

export const CRAWLING_TYPE_I18N = {
  [CrawlingType.NotAllowed]: 'Crawling untersagt',
  [CrawlingType.AllowedWithKamVerification]: 'Crawling erlaubt nach KAM-Freigabe',
  [CrawlingType.AllowedWithoutKamVerification]: 'Crawling erlaubt ohne KAM-Freigabe',
};
